import { inject, Injectable, PLATFORM_ID, signal, Signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'kcc20-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly platformId = inject(PLATFORM_ID);

  private readonly _theme = signal<Theme>('dark');
  readonly theme: Signal<Theme> = this._theme.asReadonly();

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const raw = localStorage.getItem(STORAGE_KEY);
      const saved: Theme | null =
        raw === 'dark' || raw === 'light' ? raw : null;
      const systemPreferred: Theme = window.matchMedia(
        '(prefers-color-scheme: light)',
      ).matches
        ? 'light'
        : 'dark';
      this.applyTheme(saved ?? systemPreferred);
    }
  }

  toggle(): void {
    this.applyTheme(this.theme() === 'dark' ? 'light' : 'dark');
  }

  private applyTheme(theme: Theme): void {
    this._theme.set(theme);
    if (!isPlatformBrowser(this.platformId)) return;
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }
}
